export default class StickySection {


	// Constructor
	constructor(asscroll, element, content) {
		this.asscroll = asscroll;
		this.element = element;
		this.content = content;
		this.scroll = this.scroll.bind(this);
		this.resize = this.resize.bind(this);

		this.resetRects()
		window.addEventListener('resize', this.resize);

		// Options for the observer (which mutations to observe)
		const config = { attributes: false, childList: true, subtree: true };


		let mutationTimeout;

		// Using an observer here to try and account for any weird embedded iframes. 
		// In our current case, Constant Contact forms
		const callback = (mutationsList, observer) => {
			clearTimeout(mutationTimeout)
			mutationTimeout = setTimeout(() => {
				this.resetRects()
				if (this.observer) {
					this.observer.disconnect()
				}
			}, 250)
		};

		this.observer = new MutationObserver(callback);
		this.observer.observe(this.element, config);
	}


	// Public Methods
	destroy() {
		this.disable();
		delete this.asscroll;
		delete this.content;
		delete this.element;
	}
	enable() {
		this.asscroll.on('update', this.scroll);
	}
	disable() {
		this.asscroll.off('update', this.scroll);
	}

	resize() {
		setTimeout(() => {
			console.log('resize rects')
			this.resetRects()
		})
	}

	resetRects() {
		this.elementRect = this.element.getBoundingClientRect()
		this.contentRect = this.content.getBoundingClientRect()
	}

	// Event Handlers
	scroll({ currentPos }) {

		const { top } = this.element.getBoundingClientRect();

		const elementHeight = this.elementRect.height;
		const contentHeight = this.contentRect.height;

		const windowHeight = window.innerHeight;
		const height = windowHeight - elementHeight;

		//const percent = Math.min(1, Math.max(0, top / height));
		if (contentHeight > windowHeight) {
			this.element.classList.remove('is-bottom');
			this.element.classList.remove('is-sticky');
			this.content.style.transform = 'translate3d(0, 0, 0)';
		} else if (top + elementHeight <= contentHeight) {
			this.element.classList.add('is-bottom');
			this.element.classList.remove('is-sticky');
			this.content.style.transform = 'translate3d(0, 0, 0)';
		} else if (top <= 0) {
			this.element.classList.remove('is-bottom');
			this.element.classList.add('is-sticky');
			this.content.style.transform = `translate3d(0, ${currentPos}px, 0)`;
		} else {
			this.element.classList.remove('is-bottom');
			this.element.classList.remove('is-sticky');
			this.content.style.transform = 'translate3d(0, 0, 0)';
		}
	}


}
